// Préférences par navigateur (favoris, interfaces récentes) — stockées en localStorage, sans passer par le back.
const FAV_KEY = 'tsk-favorite-projects';
const RECENT_KEY = 'tsk-recent-projects';
const MAX_RECENTS = 5;

function read(key) {
  try {
    const value = JSON.parse(window.localStorage.getItem(key));
    return Array.isArray(value) ? value : [];
  } catch (e) {
    return [];
  }
}

function write(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) { /* localStorage unavailable */ }
  window.dispatchEvent(new Event('tsk-prefs-changed'));
}

export const getFavorites = () => read(FAV_KEY);

export function toggleFavorite(projectId) {
  const favs = getFavorites();
  const next = favs.includes(projectId) ? favs.filter((id) => id !== projectId) : [projectId, ...favs];
  write(FAV_KEY, next);
  return next;
}

export const getRecents = () => read(RECENT_KEY);

export function touchRecent(projectId) {
  write(RECENT_KEY, [projectId, ...getRecents().filter((id) => id !== projectId)].slice(0, MAX_RECENTS));
}

// ——— Thème : "auto" (suit le thème du système, par défaut), "light" ou "dark" ———
const THEME_KEY = 'tsk-theme';
const MODES = ['auto', 'light', 'dark'];
const systemQuery = () => window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)');

export function getThemeMode() {
  try {
    const saved = window.localStorage.getItem(THEME_KEY);
    if (MODES.includes(saved)) return saved;
  } catch (e) { /* localStorage unavailable */ }
  return 'auto';
}

// Pages publiques (aperçu partagé, photo) : toujours en thème clair. Sinon, chez un visiteur dont le système est en
// mode sombre, tout l'écran est noir (#121212) le temps que la page se charge.
const isPlayerRoute = () => /^\/(project\/[^/]+\/preview|photo\/)/.test(window.location.pathname);

// Thème réellement affiché ("light" | "dark").
export function getTheme() {
  if (isPlayerRoute()) return 'light';
  const mode = getThemeMode();
  if (mode !== 'auto') return mode;
  const q = systemQuery();
  return q && q.matches ? 'dark' : 'light';
}

export function applyTheme() {
  document.documentElement.setAttribute('data-theme', getTheme());
}

// Applique le thème au démarrage et suit les changements du système en direct (mode auto).
export function initTheme() {
  applyTheme();
  const q = systemQuery();
  if (!q) return;
  const onChange = () => {
    if (getThemeMode() === 'auto') {
      applyTheme();
      window.dispatchEvent(new Event('tsk-prefs-changed'));
    }
  };
  if (q.addEventListener) q.addEventListener('change', onChange);
  else if (q.addListener) q.addListener(onChange);
}

// Bascule clair <-> sombre (fixe le choix ; sans choix, le thème suit le système)
export function toggleTheme() {
  const next = getTheme() === 'dark' ? 'light' : 'dark';
  try {
    window.localStorage.setItem(THEME_KEY, next);
  } catch (e) { /* localStorage unavailable */ }
  applyTheme();
  window.dispatchEvent(new Event('tsk-prefs-changed'));
  return next;
}

// ——— Densité d'affichage : "comfortable" (par défaut) ou "compact" ———
const DENSITY_KEY = 'tsk-density';

export function getDensity() {
  try {
    const saved = window.localStorage.getItem(DENSITY_KEY);
    if (saved === 'compact' || saved === 'comfortable') return saved;
  } catch (e) { /* localStorage unavailable */ }
  return 'comfortable';
}

export function applyDensity(density = getDensity()) {
  document.documentElement.setAttribute('data-density', density);
}

export function setDensity(density) {
  try { window.localStorage.setItem(DENSITY_KEY, density); } catch (e) { /* ignore */ }
  applyDensity(density);
  window.dispatchEvent(new Event('tsk-prefs-changed'));
}

applyDensity();
